import { Cursor, DatabaseAdapterEvent, EditorClient, EditorClientEvent, } from "@operational-transformation/plaintext-editor";
import mitt from "mitt";
import * as Utils from "./utils";
export var FirepadEvent;
(function (FirepadEvent) {
    FirepadEvent["Ready"] = "ready";
    FirepadEvent["Synced"] = "synced";
    FirepadEvent["Undo"] = "undo";
    FirepadEvent["Redo"] = "redo";
    FirepadEvent["Error"] = "error";
})(FirepadEvent || (FirepadEvent = {}));
export class Firepad {
    constructor(databaseAdapter, editorAdapter, options) {
        if (!new.target) {
            return new Firepad(databaseAdapter, editorAdapter, options);
        }
        this._ready = false;
        this._zombie = false;
        this._options = options;
        this._databaseAdapter = databaseAdapter;
        this._editorAdapter = editorAdapter;
        this._editorClient = new EditorClient(databaseAdapter, editorAdapter);
        this._emitter = mitt();
        this._init();
    }
    _init() {
        this._databaseAdapter.on(DatabaseAdapterEvent.Ready, () => {
            this._ready = true;
            const { defaultText } = this._options;
            if (defaultText && this.isHistoryEmpty()) {
                this.setText(defaultText);
                this.clearUndoRedoStack();
            }
            this._trigger(FirepadEvent.Ready, true);
        });
        this._editorClient.on(EditorClientEvent.Synced, (synced) => {
            setTimeout(() => {
                this._trigger(FirepadEvent.Synced, synced);
            });
        });
        this._editorClient.on(EditorClientEvent.Undo, (undoOperation) => {
            setTimeout(() => {
                this._trigger(FirepadEvent.Undo, undoOperation);
            });
        });
        this._editorClient.on(EditorClientEvent.Redo, (redoOperation) => {
            setTimeout(() => {
                this._trigger(FirepadEvent.Redo, redoOperation);
            });
        });
        this._editorClient.on(EditorClientEvent.Error, (error) => {
            setTimeout(() => {
                this._trigger(FirepadEvent.Error, error);
            });
        });
    }
    getConfiguration(option) {
        return option in this._options ? this._options[option] : null;
    }
    on(event, listener) {
        var _a;
        return (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.on(event, listener);
    }
    off(event, listener) {
        var _a;
        return (_a = this._emitter) === null || _a === void 0 ? void 0 : _a.off(event, listener);
    }
    _trigger(event, payload) {
        return this._emitter.emit(event, payload);
    }
    isHistoryEmpty() {
        this._assertReady("isHistoryEmpty");
        return this._databaseAdapter.isHistoryEmpty();
    }
    setUserId(userId) {
        this._databaseAdapter.setUserId(userId);
        this._options.userId = userId;
    }
    setUserColor(userColor) {
        this._databaseAdapter.setUserColor(userColor);
        this._options.userColor = userColor;
    }
    setUserName(userName) {
        this._databaseAdapter.setUserName(userName);
        this._options.userName = userName;
    }
    getText() {
        this._assertReady("getText");
        return this._editorAdapter.getText();
    }
    setText(text = "") {
        this._assertReady("setText");
        this._editorAdapter.setText(text);
        this._editorAdapter.setCursor(new Cursor(0, 0));
    }
    clearUndoRedoStack() {
        this._assertReady("clearUndoRedoStack");
        this._editorClient.clearUndoRedoStack();
    }
    dispose() {
        this._zombie = true;
        this._databaseAdapter.dispose();
        this._editorAdapter.dispose();
        this._editorClient.dispose();
        if (this._emitter) {
            this._trigger(FirepadEvent.Ready, false);
            this._emitter.all.clear();
            this._emitter = null;
        }
    }
    _assertReady(func) {
        Utils.validateTruth(this._ready, `You must wait for the "ready" event before calling ${func}.`);
        Utils.validateFalse(this._zombie, `You can't use a Firepad after calling dispose()!  [called ${func}]`);
    }
}
